'use strict'

module.exports = function vendorPrefixes () {
  return [
    '-ms-', 'mso-', // Microsoft
    '-moz-',	      // Mozilla
    '-o-', '-xv-',  // Opera Software
    '-atsc-',       //	Advanced Television Standards Committee
    '-wap-',        //	The WAP Forum
    '-khtml-',      //	KDE
    '-webkit-',     //	Apple
    'prince-',      //	YesLogic
    '-ah-',         //	Antenna House
    '-hp-',         //	Hewlett Packard
    '-ro-',         //	Real Objects
    '-rim-',        //	Research In Motion
    '-tc-'          //	TallComponents
  ]
}
